import React, { useState, useEffect } from "react";

import { fetchUserMe, updateUser } from "libLegacy/api/user";

import { SolutionsFrame } from "components/solutions/SolutionsFrame";
import { BlockStandard } from "components/admin/BlockStandard";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Grid,
  TextField,
  Button,
} from "@mui/material";
import { useToken } from "contexts/UserContext";

const FRAME_DATA = {
  title: "Contrato de energia verde",
  buttonText: "Ir para a loja virtual",
};

export const GreenEnergyUnavailable = ({ history }) => {
  const token = useToken();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [phone, setPhone] = useState<string>("");

  useEffect(() => {
    const load = async () => {
      try {
        const data = await fetchUserMe(`Bearer ${token}`);
        setPhone(data.phone || "");
      } finally {
        setIsLoading(false);
      }
    };
    load();
  }, [token]);

  const handleClick = () => {
    history.push("/frames/store");
  };

  const handleSubmit = async () => {
    if (phone) {
      setIsLoading(true);
      try {
        await updateUser(`Bearer ${token}`, { phone });
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <SolutionsFrame {...FRAME_DATA} onButtonClick={handleClick}>
      <BlockStandard hideDivider>
        <Typography variant="h2">Obrigado pelo envio!</Typography>
        <Typography variant="h2">
          Infelizmente não temos oferta disponível na sua região no momento.
        </Typography>
        <Typography>
          Deixe seu contato, que retornaremos contato assim que tivermos uma
          oferta atrativa pra você!
        </Typography>
        <Grid item container gap={2} alignItems="center">
          <TextField
            sx={{ flex: 2 }}
            value={phone}
            onChange={({ target }) => setPhone(target.value)}
          />
          <Button
            sx={{ flex: 1 }}
            variant="contained"
            disabled={isLoading || !phone}
            onClick={handleSubmit}
          >
            Salvar
          </Button>
        </Grid>
      </BlockStandard>

      <BlockStandard hideDivider>
        <Typography variant="h2">Conheça nossa loja virtual</Typography>
        <Typography>
          Comece a poupar com os dispositivos IoT que garantem que os
          ar-condicionados funcionem somente quando necessário e medidores
          inteligentes que acompanham seu consumo em tempo real.
        </Typography>
        <Grid item container direction="row" gap={2}>
          <Card sx={{ flex: 1, flexDirection: "column " }}>
            <CardMedia
              sx={{ flex: 1, height: 200 }}
              image="https://www.enermatch.com/wp-content/uploads/2024/11/foto-principal-smartmeter.jpg"
            />
            <CardContent sx={{ flex: 1 }}>
              <Typography variant="body2">
                Medidor Inteligente Wi-Fi com TCs
              </Typography>
              <Typography>A partir de:</Typography>
              <Typography variant="body2">R$ 149,00</Typography>
            </CardContent>
          </Card>
          <Card sx={{ flex: 1 }}>
            <CardMedia
              sx={{ flex: 1, height: 200 }}
              image="https://www.enermatch.com/wp-content/uploads/2024/11/infra-vermelho-01.jpg"
            />
            <CardContent sx={{ flex: 1 }}>
              <Typography variant="body2">
                Controle Remoto Inteligente Un. Infra
              </Typography>
              <Typography>A partir de:</Typography>
              <Typography variant="body2">R$ 149,00</Typography>
            </CardContent>
          </Card>
        </Grid>
      </BlockStandard>
    </SolutionsFrame>
  );
};
